/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2021
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/

import * as segmentCustom from '../segment/segmentCustom';

/**
 * @deprecated See [segment event migration](https://pages.github.ibm.com/watson-engagement-advisor/wea-conversational-ui/architectural-guidelines/segment.html#migration-from-custom-events).
 *
 *  Sends a custom event to segment
 */
export const customEvent = segmentCustom.customEvent;

/**
 * @deprecated See [segment event migration](https://pages.github.ibm.com/watson-engagement-advisor/wea-conversational-ui/architectural-guidelines/segment.html#migration-from-custom-events).
 *
 *  Sends a custom event with custom values to segment
 */
export const customEventWithValues = segmentCustom.customEventWithValues;
